export const COLORS = {
    orange: '#ff7205',
    white: '#fff'
};